import React, { useState, useEffect } from 'react';
import InputSimple from '../../components/InputSimple';
import { PostAsync, Inputs, format } from '../../helpers/Functions';
import StateContext from '../../helpers/ContextState';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import BotonVolverHome from '../../components/BotonVolverHome';
import Comentarios from '../comentarios';
import '../../components/HistorialTable.css';

const App = () => {
  const context = React.useContext(StateContext);
  const [inputs, setInputs] = useState({});
  const [historial, setHistorial] = useState([]);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  useEffect(() => {
    let mounted = true;
    getInit(mounted);
    return () => { mounted = false; };
  }, []);

  const getInit = (mounted) => {
    PostAsync('Configuracion', 'GetSystemRebate', {}, { ...context }).then((response) => {
      if (response.data !== undefined && mounted) {
        const d = response.data || {};
        d.base_reterebate = format((d.base_reterebate || 0) * 1);
        d.observacion = '';
        setInputs(d);
      }
    });
    PostAsync('Configuracion', 'GetHistorialSystemRebate', {}, { ...context }).then((response) => {
      if (response.historial !== undefined && mounted) {
        setHistorial(response.historial);
      }
    });
  };

  const onChange = (e) => Inputs(e, inputs, setInputs);

  const onSubmit = (e) => {
    e.preventDefault();
    let base = inputs.base_reterebate || '0';
    if (typeof base === 'string') {
      if (base.includes(',')) base = base.substring(0, base.indexOf(','));
      base = base.replaceAll('.', '');
    }
    PostAsync('Configuracion', 'SetSystemRebate', { ...inputs, base_reterebate: base }, { ...context }).then(() => {
      setReset(true);
      getInit(true);
    });
  };

  return (
    <>
      <Row className="mb-4">
        <form onSubmit={onSubmit}>
          <Row className="mb-4">
            <Col xs="12" md="2">
              <InputSimple
                className="form-control"
                type="number"
                name="reterebate_juridica"
                step={0.0001}
                defaultValue={inputs.reterebate_juridica}
                placeholder="Rete Rebate Persona Jurídica"
                onChange={onChange}
              />
            </Col>
            <Col xs="12" md="2">
              <InputSimple
                className="form-control"
                type="number"
                name="reterebate_natural"
                step={0.0001}
                defaultValue={inputs.reterebate_natural}
                placeholder="Rete Rebate Persona Natural Declarante"
                onChange={onChange}
              />
            </Col>
            <Col xs="12" md="2">
              <InputSimple
                className="form-control"
                type="text"
                name="base_reterebate"
                defaultValue={inputs.base_reterebate}
                placeholder="Base Rete Rebate"
                onChange={onChange}
              />
            </Col>
            <Col xs="12" md="3">
              <InputSimple
                className="form-control"
                type="text"
                name="observacion"
                defaultValue={inputs.observacion}
                placeholder="Observación"
                onChange={onChange}
              />
            </Col>
            <Col xs="12" md="1">
              <BotonVolverHome />
            </Col>
            <Col xs="12" md="2">
              <Button type="submit">Actualizar</Button>
            </Col>
          </Row>
        </form>
      </Row>

      <div className="row">
        <div className="col h5 mt-3">Historial cambios Tributaria Rebate</div>
      </div>
      <div className="row">
        <div className="col">
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">#</th>
                <th className="text-center">Fecha de cambio</th>
                <th className="group-rete-iva">Rete Persona Jurídica Anterior</th>
                <th className="group-rete-iva act">Rete Persona Jurídica Actual</th>
                <th className="group-rete-ica">Rete Persona Natural Decl. Anterior</th>
                <th className="group-rete-ica act">Rete Persona Natural Decl. Actual</th>
                <th className="group-base-iva">Base Anterior</th>
                <th className="group-base-iva act">Base Actual</th>
                <th className="text-center">Observación</th>
                <th className="text-center">Fecha Aplicación</th>
                <th className="text-center">Funcionario</th>
              </tr>
            </thead>
            <tbody>
              {historial && historial.length > 0 ? (
                historial.map((row, key) => (
                  <tr key={key}>
                    <td className="text-center">{key + 1}</td>
                    <td className="text-center">{row.fecha_cambio || 'N/A'}</td>
                    <td className="group-rete-iva">{row.reterebate_juridica_anterior ?? 'N/A'}</td>
                    <td className="group-rete-iva act">{row.reterebate_juridica_actual ?? 'N/A'}</td>
                    <td className="group-rete-ica">{row.reterebate_natural_anterior ?? 'N/A'}</td>
                    <td className="group-rete-ica act">{row.reterebate_natural_actual ?? 'N/A'}</td>
                    <td className="group-base-iva">{format((row.base_reterebate_anterior || 0) * 1)}</td>
                    <td className="group-base-iva act">{format((row.base_reterebate_actual || 0) * 1)}</td>
                    <td className="text-center" title={row.observacion || ''}>
                      {row.observacion && row.observacion.length > 20
                        ? row.observacion.substr(0, 20) + '...'
                        : (row.observacion || 'Sin Observación')}
                    </td>
                    <td className="text-center">{row.fecha_aplicacion || 'N/A'}</td>
                    <td className="text-center">{row.funcionario_name || 'Desconocido'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">No hay registros en el historial.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <Row>
        <Col xs="12">
          {!reset ? <Comentarios id={"TributariaRebate"} /> : false}
        </Col>
      </Row>
    </>
  );
};

export default App;
